import type { ReactNode } from "react";
import { hasEffectivePermission, useRbac } from "@shared/rbac/guards";

export function useCatalogWritePermission() {
  const { user } = useRbac();
  return hasEffectivePermission(user, "catalog:write");
}

export function CatalogWrite({ children }: { children: ReactNode }) {
  return useCatalogWritePermission() ? <>{children}</> : null;
}
